/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type special_allocations_UpdateParentAbsenceRequest = {
    /**
     * Comment is the optional note (max 500 characters)
     */
    comment?: string;
    /**
     * FromDatetime is when the absence begins (required). Send a plain RFC3339 date-time
     * string, or a date-only string ("2006-01-02").
     */
    from_datetime: string;
    /**
     * FullDay reports a full-day absence
     */
    full_day?: boolean;
    /**
     * Reason is the absence reason
     */
    reason: special_allocations_UpdateParentAbsenceRequest.reason;
    /**
     * ToDatetime is when the absence ends (required). Same formats as from_datetime.
     */
    to_datetime: string;
};
export namespace special_allocations_UpdateParentAbsenceRequest {
    /**
     * Reason is the absence reason
     */
    export enum reason {
        ILLNESS = 'ILLNESS',
        VACATION = 'VACATION',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
    }
}

